module.exports = __webpack_public_path__ + "img/writing_words-hover.71ddb2a1.svg";